import { Box, Flex, Link, theme, Text } from "@xometry/xometry_loft";
import { css } from "@emotion/react";
import { useConfig } from "../../proposals/contexts/configContext";
import { content } from "./CustomerRFQLogin.style";

const title = css`
  font-size: 32px;
  font-weight: 500;
  line-height: 38px;
  margin-bottom: 12px;
  text-align: center;
`;

const messageContainer = css`
  width: 100%;
  margin: 0 auto;
`;

const MfaMessage = () => {
  const { origins } = useConfig();

  return (
    <div css={content}>
      <Flex flexDirection="column">
        <Box
          textAlign="center"
          fontWeight={theme.fontWeights.bold}
          paddingBottom={theme.space[8]}
        >
          <div css={title}>Verify Your Identity</div>
        </Box>
        <div css={messageContainer}>
          <Box>
            <Text color={theme.colors.darkBlues[100]} kind="body">
              Multi-Factor Authentication is activated on your account. Please
              continue to log in again.
            </Text>
          </Box>
          <Box marginTop={40} width="100%">
            <Link
              style={{
                display: "block",
                backgroundColor: "#106aed",
                color: "#fff",
                padding: "10px",
                borderRadius: "4px",
                fontWeight: "bold",
                textAlign: "center",
              }}
              href={`${origins.www}/login?destination=${encodeURIComponent(
                window.location.pathname
              )}&domain=www`}
            >
              Continue
            </Link>
          </Box>
        </div>
      </Flex>
    </div>
  );
};

export default MfaMessage;
